import { createFileRoute } from '@tanstack/react-router';
import { Search } from '~/pages';
import { protectRoute } from '~/utilities';

export const Route = createFileRoute('/search')({
  component: Search,
  beforeLoad: protectRoute,
});
